import { matchPath } from "react-router";
import { TAX_FILING_PATH } from "../paths";
import { getDefaultTaxYear, TaxYear } from "../../../shared/constants/taxYear";

export const getCurrentTaxFilingYear = (currentPathname?: string): TaxYear => {
  const pathname = currentPathname || window.location.pathname;
  const defaultTaxYear = getDefaultTaxYear();

  if (pathname.startsWith("/member/1099-filing")) {
    return 2023 as TaxYear;
  }

  const matched = matchPath<{ year?: string }>(pathname, {
    path: TAX_FILING_PATH
  });

  const currentYear = Number(matched?.params.year) || defaultTaxYear;

  return currentYear as TaxYear;
};
